export default "__VITE_ASSET__CqunXL6y__"